<template>
    <v-dialog v-model="editYearOfStudyDialog" max-width="576" persistent>
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="setYearOfStudy()" :color="successColor" icon>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                            mdi-pencil
                        </v-icon>
                    </template>
                    <span>Edit</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Edit Year of Study
            </v-card-title>
            <v-card-text>
                <v-form ref="editYearOfStudy" v-model="valid" lazy-validation>
                    <v-text-field v-model="currentYearOfStudy.year" clearable label="Year" :rules="yearRules" required>
                    </v-text-field>
                    <v-text-field v-model="currentYearOfStudy.label" clearable label="Label"
                    hint="This is the text that the applicants see in their ORA form" required>
                    </v-text-field>
                    <v-select v-model="currentYearOfStudy.default"
                        hint="Set as default choice for the Online Residence Application form" :items="defaultItems"
                        label="Default" persistent-hint :rules="defaultRules" required>
                    </v-select>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn ref="confirmBtn" class="white--text" :color="successColor" :disabled="!valid"
                    @click="editYearOfStudy()">
                    Save
                </v-btn>
                <v-btn :color="warningColor" @click="closeDialog()">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'year-of-study-edit',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            currentYearOfStudy: '',
            defaultItems: [{
                    text: 'Yes',
                    value: '1'
                },
                {
                    text: 'No',
                    value: '0'
                }
            ],
            defaultRules: [
                v => !(v === "") || 'Default is required',
            ],
            editYearOfStudyDialog: false,
            yearRules: [
                v => !!v || 'Year is required'
            ],
            valid: true
        }
    },
    methods: {
        closeDialog() {
            this.editYearOfStudyDialog = false;
        },
        editYearOfStudy() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?updateEntity`;

            if (this.$refs.editYearOfStudy.validate()) {
                // Parse array into string
                formData.append('data', JSON.stringify(this.currentYearOfStudy));
                formData.append('mode', 'updateEntity');
                formData.append('type', 'YearOfStudy');

                // Loading icon
                this.$refs.confirmBtn.loading = true;

                // Post request
                fetch(api, {
                        method: 'POST',
                        body: formData
                    })
                    .then(function (response) {
                        // Return JSON response
                        return response.json();
                    })
                    .then(function (json) {
                        // Success result
                        if (json.result.match(/OK/i)) {
                            that.$emit('setNotification', '#1dc9b7', 'mdi-check-circle', `${that.currentYearOfStudy.year} has been successfully updated.`, true);
                        } else if (json.message.match(/UNAUTHORIZED/i)) {
                            that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `You are not authorized to perform this action. Please refresh your application.`, true);
                        } else {
                            that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `${that.currentYearOfStudy.year} could not be updated. Please contact your system administrator.`, true);
                        }

                        that.$emit('refreshData');
                        that.closeDialog();
                        that.$refs.confirmBtn.loading = false;
                    })
                    .catch(function () {
                        that.$emit('refreshData');
                        that.closeDialog();
                        that.$refs.confirmBtn.loading = false;
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `An error occurred. Please contact your system administrator.`, true);
                    });
            }
        },
        setYearOfStudy() {
            this.currentYearOfStudy = {
                ...this.item
            };

            if (this.$refs.editYearOfStudy) {
                this.$refs.editYearOfStudy.resetValidation();
            }
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        primaryColor() {
            return '#5867dd';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>